"use strict";

module.exports = function extend(target, source) {
    var ret = {};
    if (target) {
        for (var key in target) {
            ret[key] = target[key];
        }
    }
    if (source) {
        for (var _key in source) {
            if (source.hasOwnProperty(_key) && source[_key] !== undefined) {
                ret[_key] = source[_key];
            }
        }
    }
    return ret;
};